import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/v2/Message";
import { getReturnsExceptionMessage } from "./utils/getReturnsExceptionMessage";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import Link from "next/link";
import styles from "./ReturnsExclusions.module.scss";

type Props = {
  browsePageHierarchy: Array<{ categoryId: string }>;
};

export function ReturnsExclusions({ browsePageHierarchy }: Props) {
  const returnsExceptionMessage =
    getReturnsExceptionMessage(browsePageHierarchy);

  if (!returnsExceptionMessage) return null;

  return (
    <Message
      type="information"
      dataTest="returns:exception-message"
      title={returnsExceptionMessage.title}
      body={
        <>
          <p>{returnsExceptionMessage.message}</p>
          <div className={styles.buttonWrapper}>
            <Link href="/customer-services/returns?dt=informationOnOurReturnsPolicy">
              <UnderlinedButton>Read our full returns policy</UnderlinedButton>
            </Link>
          </div>
        </>
      }
    />
  );
}
